export default __webpack_public_path__ + "static/media/password svg.ab0a4b00.svg";